module.exports = __webpack_public_path__ + "static/media/dethkeik.280f55cd.svg";